export function formatAZN(n) {
  return Math.round(n).toLocaleString("az-AZ") + " ₼";
}

export function computeLoan(amount, period) {
  const total = amount * (1 + 0.1 * (period / 12));
  return { total, monthly: total / period };
}
